import { AddInError } from './addInError';

export class NoMailItemError extends AddInError {
  constructor(message: string, context?: Record<string, unknown>) {
    super(message, context);
    this.name = 'NoMailItemError';
    Object.setPrototypeOf(this, NoMailItemError.prototype);
  }
}
